// Shown in a cell when there is no value to display.
export default 'N/A'
